import React, { useState } from "react";
import "./MessageA13ExplorePacks.css";



const MessageA13ExplorePacks = (props) => {
  const {item} = props
  let packsData = JSON.parse(item?.text)
 
  const [selected, setSelected] = useState(null);

  const handleSelect = (packType) => {
    setSelected(packType); // only one selection allowed
  };

  return (
    <div className="packs-container">
      <h2 className=" pack-subtitle A3f" >What would you like to do today?</h2>
      <p className="pack-subtitle A3f">
        Manage your packs and channels by choosing from below options
      </p>
      <div className="packs-list action-tab">
        {packsData?.map((pack, index) => {
          const isSelected = selected === pack.packType;
          return (
            <div
              key={index}
              className={`pack-card ${isSelected ? "selected" : ""}`}
              onClick={() => {
                props?.setErrors((prevErrors) => {
                  const updatedErrors = {
                    ...prevErrors,
                    [props?.index]: { key1: pack?.packType, displayName: pack?.packType },
                  };
                  console.log("Updated Errors after user selection:", updatedErrors);
                  return updatedErrors;
                });
                 setSelected(pack?.packType)
                }}
              
            >
              <div className="icon-circle">
                <img src={pack.imageLink} alt={pack.packTypeHeader} />
              </div>
              <h3>{pack.packTypeHeader}</h3>
              <p>{pack.packTypeDesc}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MessageA13ExplorePacks;
